var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-container',[_c('v-row',[_c('v-col',[_c('h3',[_vm._v("Länder verwalten")]),_c('span',[_vm._v("Verwalten Sie die Verfügbaren Länder für die Coaches")])])],1),_c('v-row',[_c('v-col',[_c('CountriesTable')],1)],1),_c('v-row',[_c('v-col',[_c('NewCountry')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }